export default "__VITE_ASSET__7f3db648__"